module.exports = __webpack_public_path__ + "static/media/info_collection_bg_right.cf539e54.svg";